import React from 'react';
import coverbackground from '../../assets/eats.jpg';
import ReusableScrollCard from '../../components/ReusableScrollcard/ReusableScrollcard';

class ScrollEats extends React.Component {
  render () { 
   return(
  
  <ReusableScrollCard             
    
        
        description="Eats"
        coverbackground={coverbackground}
     />
  
  );
 }
}   

export default ScrollEats;